import React, { useState, useEffect } from 'react';
import { CategoryBox } from './Invoices';
import styles from './invoices.module.scss';
import { API_ROOT, sendRequest } from '../../supplementary_components/requests';
import { LoadingIcon } from '../../supplementary_components/loading_icon';
import { ItemOnPopup } from '../../general_components/content_management/reusableItems/itemOnPopup';
import {  addPopup } from '../../supplementary_components/store';
function sortLoads(loadsArray) {
    return loadsArray.reduce((acc, load) => {
        const { loadStatus, amountForInvoice, invoiceNumber } = load;
        const invoiceAmount = loadStatus === "Invoiced" ||  !invoiceNumber ? amountForInvoice : 0;

        // Use a conditional to find the target category key
        let targetCategory;

        if (loadStatus === "Completed") {
            targetCategory = acc.completed;
        } else if (loadStatus === "ReadyForInvoice" || loadStatus === "Cancelled") {
            targetCategory = acc.readyForInvoice;
        } else if (loadStatus === "Invoiced") {
            targetCategory = acc.invoiced;
        }
        
        // If a target category was found, update the nested properties
        if (targetCategory) {
            targetCategory.loads.push(load);
            targetCategory.grandTotal += invoiceAmount;
        }

        return acc;
    }, {
        // --- Initial Accumulator Structure ---
        completed: {
            loads: [],
            grandTotal: 0
        },
        readyForInvoice: {
            loads: [],
            grandTotal: 0
        },
        invoiced: {
            loads: [],
            grandTotal: 0
        }
    });
}
export const NotFactoredLoadsManager = ({ popupData }) => {
    const setNotFactoredManagableLoadExists = popupData?.setNotFactoredManagableLoadExists;
    const setCompletedButNotFactoredLoadsCount = popupData?.setCompletedButNotFactoredLoadsCount;
    const [data, setData] = useState(null);
    const _setData = (data) =>{
        // if(!invoiceIds || invoiceIds.length === 0) return null;
        // const currentLoads = invoiceIds.map(id => loadsById[id]).filter(Boolean);
        const sortedData = sortLoads(data);
        
        try {
            if(sortedData){
                setNotFactoredManagableLoadExists(sortedData.completed.loads.length > 0 || sortedData.readyForInvoice.loads.length > 0 || sortedData.invoiced.loads.length > 0);
                setCompletedButNotFactoredLoadsCount(sortedData.completed.loads.length + sortedData.readyForInvoice.loads.length);
            }   
        } catch (error) {
            
        }
        

        setData(sortedData);
    };
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
	const [updatingCategory, setUpdatingCategory] = useState(null);
    const updateData = (signal)=>{
        setLoading(true);
		sendRequest('GET', API_ROOT+`loads/notFactoregLoadsPage`, signal, (respData) => {
			setError(null);
            _setData(respData);
            setLoading(false);
			setUpdatingCategory(null);
		}, (e) => {
            setError(e);
            setLoading(false);
        }, null);
	}

    useEffect(
        () => {
            const controller = new AbortController();
            const signal = controller.signal;
            updateData(signal);
            return () => {
                // cancel the request before component unmounts
                controller.abort();
            };
        // eslint-disable-next-line
        }, []
    );
    if (error !== null) return <div className='errorMessage'>{error.customError?error.customError:"Something went wrong"}</div>
    if (loading && !data) return<div style={{height:"10rem", width: "100%"}}><LoadingIcon state={true} height={'10rem'} /></div>;
    if (!data) return <div className={styles.noLoadsPresent}>No Loads</div>; // Fallback if data is empty after loading
    
    return  <div className={styles.popupContainer}> 
        <div className={styles.container}>
            {Object.keys(data).map((category) => {
                return <CategoryBox key={category} category={category} data={data[category]} customActionOnceClickedOnLoadNumber={customActionOnceClickedOnLoadNumber} updatingCategory={updatingCategory} setUpdatingCategory={setUpdatingCategory} setError={setError} updateData={updateData} unfactoredLoads={true} />
            })}

        </div>
    </div>
    
}

const customActionOnceClickedOnLoadNumber = (load)=>{
    addPopup({
        content:ItemOnPopup,
        popupData: {
            itemType: "load",
            itemId: load.id,
            
        },
        customWidth: "90%",
        customMaxWidth: "1700px",
        customMinWidth: "880px",
        EZCloseAllowed:true
    })
}